// Utils
import { createNamespace, addUnit } from '../utils';
import { emit, inherit } from '../utils/functional';
import { BORDER_SURROUND } from '../utils/constant';
const [createComponent, bem] = createNamespace('password-input');
function PasswordInput(h, props, slots, ctx) {
    const { mask, value, length, gutter, focused, errorInfo, readonly, disabled } = props;
    const info = errorInfo || props.info;
    const Points = [];
    for (let i = 0; i < length; i++) {
        const char = value[i];
        const showBorder = !gutter;
        const showCursor = focused && i === value.length;
        let style;
        if (i !== 0 && gutter) {
            style = { marginLeft: addUnit(gutter) };
        }
        Points.push(<li class={[{ [BORDER_SURROUND]: showBorder }, bem('item', { focus: showCursor, dis: disabled })]} style={style}>
        {mask ? (<i style={{ visibility: char ? 'visible' : 'hidden' }}/>) : (char)}
        {showCursor && <div class={bem('cursor')}/>}
      </li>);
    }
    return (<div class={bem()}>
      <ul class={[bem('security'), { [BORDER_SURROUND]: false && !gutter }]} onTouchstart={(event) => {
        event.stopPropagation();
        emit(ctx, 'focus', event);
    }} {...inherit(ctx, true)}>
        {Points}
      </ul>
      {info && <div class={bem(errorInfo ? 'error-info' : 'info')}>{info}</div>}
    </div>);
}
PasswordInput.props = {
    info: String,
    gutter: [Number, String],
    focused: Boolean,
    errorInfo: String,
    mask: {
        type: Boolean,
        default: true,
    },
    value: {
        type: String,
        default: '',
    },
    length: {
        type: [Number, String],
        default: 6,
    },
    readonly: Boolean,
    disabled: Boolean,
};
export default createComponent(PasswordInput);
